import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import {
  buildTableData,
  getColumnClassName,
  getValueClassName,
} from 'src/components/page/financial-summary/financial-summary-table.utils'
import { RatioLink } from 'src/components/page/ratios/ratios'
import { useStockReportContext } from 'src/contexts/stock-report.context'

import * as styles from './financial-summary-table.module.scss'

export const FinancialSummaryTable: React.FC = () => {
  const { report } = useStockReportContext()
  const data = buildTableData(report.financialSummary)

  return (
    <>
      <SectionHeader>Financial Summary</SectionHeader>
      <div className={styles.financialSummaryTable__container}>
        <table
          className={classNames(
            styles.financialSummaryTable__table,
            'stk-space-out-t-0',
            'enhance-colors',
          )}
        >
          <thead>
            <tr>
              {data.columns.map((column, index) => (
                <React.Fragment key={index}>
                  <th
                    key={index}
                    className={column.className}
                    style={{ width: column.squashed ? '1%' : 'auto' }}
                  >
                    {column.hidden ? (
                      <span className="visually-hidden">{column.label}</span>
                    ) : (
                      column.label
                    )}
                  </th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.values ? (
                  <>
                    <td>
                      {row.id ? (
                        <RatioLink id={row.id}>{row.label}</RatioLink>
                      ) : (
                        row.label
                      )}
                    </td>
                    <td className={'stk-text-unimportant'}>{row.unit}</td>
                    {row.values.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={getColumnClassName(data.columns, colIndex)}
                      >
                        {column ? (
                          <span className={getValueClassName(column)}>
                            {column}
                          </span>
                        ) : (
                          <ValueLocked />
                        )}
                      </td>
                    ))}
                  </>
                ) : (
                  <th colSpan={data.columns.length}>{row.label}</th>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.financialSummaryTable__brief}>
        <p className={'stk-text-small'}>{data.brief}</p>
      </div>
    </>
  )
}
